/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreditInfoDto } from '../../models/credit-info-dto';

export interface CreditHistoryLogControllerGetCreditInfo$Params {
  clientWorkspaceId: string;
}

export function creditHistoryLogControllerGetCreditInfo(http: HttpClient, rootUrl: string, params: CreditHistoryLogControllerGetCreditInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditInfoDto>> {
  const rb = new RequestBuilder(rootUrl, creditHistoryLogControllerGetCreditInfo.PATH, 'get');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreditInfoDto>;
    })
  );
}

creditHistoryLogControllerGetCreditInfo.PATH = '/api/creditHistoryLog/{clientWorkspaceId}/info';
